import { MRT_PaginationState, MRT_SortingState } from 'material-react-table';
import { useRef, useState } from 'react';
import { formatDate } from '../utils';
import dayjs from 'dayjs';

export const useTableFilter = () => {
 
  const [sorting, setSorting] = useState<MRT_SortingState>([]);

  ///*rango de fechas
  const [dateBefore, setDateBefore] = useState<string | null>(null);
  const [dateAfter, setDateAfter] = useState<string | null>(null);

  const [dateBeforeDefault, setDateBeforeDefault] = useState<string | null>(dayjs().format('YYYY-MM-DD'));
  const [dateAfterDefault, setDateAfterDefault] = useState<string | null>(dayjs().format('YYYY-MM-DD'));
  const [vendedor, setVendedor] = useState('');
  const [flota, setFlota] = useState<string | null>(null);


  ///* debouncer
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  ///* table state
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });
  const [globalFilter, setGlobalFilter] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const onChangeFilter = (term: string) => {
    // to display the search term in the search box
    setGlobalFilter(term);

    // debouncing
    if (timerRef) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(async () => {
      setSearchTerm(term);
      setPagination({
        pageIndex: 0,
        pageSize: 10,
      })
    }, 610);

  };

  const onChangeRangeDate = (range: Date[]) => {
    // Solo ejecutar cuando se hayan seleccionado ambas fechas
    if (!range || range.length < 2 || !range[1]) {
      console.log('Esperando selección completa del rango de fechas');
      return;
    }

    let after = formatDate(range[0]);
    let before = formatDate(range[1]);

    console.log('filter fecha - rango completo seleccionado');

    setDateBefore(before);
    setDateAfter(after);
    setDateBeforeDefault(before);
    setDateAfterDefault(after);
  }



  const cleanFilter = () => {
    setDateBefore(null);
    setDateAfter(null);
    setSearchTerm('');
    setGlobalFilter('');
    setVendedor('');
    setFlota(null);
    setPagination({
      pageIndex: 0,
      pageSize: 10
    })

    setDateAfterDefault(dayjs().format('YYYY-MM-DD'));
    setDateBeforeDefault(dayjs().format('YYYY-MM-DD'));
  }

  return {
    searchTerm,
    pagination,
    globalFilter,

    dateAfter,
    dateBefore,
    dateAfterDefault,
    dateBeforeDefault,

    vendedor,
    setVendedor,
    flota,
    setFlota,

    setPagination,
    setGlobalFilter,
    setSearchTerm,
    onChangeFilter,
    onChangeRangeDate,
    cleanFilter,
    sorting,
    setSorting,
  };
};
